module.exports = __webpack_public_path__ + "static/media/alpha-mechanical-services.b63e2ef6.png";